module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(false) ? _c('spinner') : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('h2', {
    staticClass: "font-w300 push-10 align-center"
  }, [_c('i', {
    staticClass: "fa fa-cloud-download fa-1x push-15-r "
  }), _vm._v("Cloud Live Monitor")]), _vm._v(" "), _c('h4', {
    staticClass: "font-w300 push-10 align-center"
  }, [_vm._v(_vm._s(_vm.GraphTitle))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.overlayParameters.liveType == 'Device') ? _c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDeviceDataType),
      expression: "selectedDeviceDataType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedDeviceDataType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "current_RMS"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorCurrentRMS[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "power"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorPower[_vm.actualLanguage]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "input_VRMS"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectorInputVRMS[_vm.actualLanguage]))])])]) : _vm._e()]), _vm._v(" "), (_vm.flagDisplayNewGraph) ? _c('div', {
    staticClass: "col-sm-12 col-lg-12"
  }, [_c('div', {
    attrs: {
      "id": "chart"
    }
  }, [_c('apexchart', {
    attrs: {
      "type": "area",
      "height": "400",
      "options": _vm.chartOptions,
      "series": _vm.chartDataSeries
    }
  })], 1)]) : _c('div', [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-content block-content-full bg-gray-lighter text-center"
  }, [_c('line-chart', {
    attrs: {
      "chartData": _vm.graphData
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.testGetLiveCloud()
      }
    }
  }, [(_vm.dataIsLoading) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-download fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelButtonDownload[_vm.actualLanguage]))])], 1)])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c6537e1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/SubComponents/ChannelCloudLiveModalDisplay.vue
// module id = 1539
// module chunks = 4